import { getAccessories } from '.';
import { extractDataFromJwt, UserIdentity } from '.';
import deepStrictEqual from 'deep-strict-equal';
export const getConfigurationPrice = ( product, prices, priceProperty = 'listPrice', fromCart, lastAddedItem, fromCbol= false,fromConfigFooter=false,skipLooseAcc=false ) => {
  const accessories = getAccessories( product );
  // get the price for exactly 1 product
  let productPrice = getProductPrice( { ...product, amount: 1 }, prices, priceProperty, fromCart );

  // this is one where I think we should be very aware of what we send in
  // say the amount is 0.001, it would devaluate the price of the accessory as well, and I am not sure we really want that
  for ( let accessory of accessories ) {
    if ( prices[accessory] ) {
      productPrice += getProductPrice( { name: accessory, amount: 1, priceUnit: 1 }, prices, priceProperty, fromCart );
    }
  }
  if(( lastAddedItem || fromCbol || !fromCart ) ){
    if(!skipLooseAcc ){
    if(product.additionalProducts  && product.additionalProducts.length > 0 ){
      productPrice += getProductPrice( { ...product.additionalProducts.firstOrDefault(), amount: 1 }, prices, priceProperty, fromCart )
    const additionalAccessories = getAccessories( product.additionalProducts.firstOrDefault() );
    for ( let accessory of additionalAccessories ) {
      if ( prices[accessory] ) {
        productPrice += getProductPrice( { name: accessory, amount: 1, priceUnit: 1 }, prices, priceProperty, fromCart );
      }
    }}
    else if(product.looseadditionalProduct && product.looseadditionalProduct.length>0){
      productPrice += getProductPrice( { ...product.looseadditionalProduct.firstOrDefault(), amount: 1 }, prices, priceProperty, fromCart )
      const looseadditionalAccessories = getAccessories( product.looseadditionalProduct.firstOrDefault() );
      for ( let looseacc of looseadditionalAccessories ) {
        if ( prices[looseacc] ) {
          productPrice += getProductPrice( { name: looseacc, amount: 1, priceUnit: 1 }, prices, priceProperty, fromCart );
        }
      }
    }
  }}
  if(fromCart){
    if(product.looseadditionalProduct && product.looseadditionalProduct.length>0){
      productPrice += getProductPrice( { ...product.looseadditionalProduct.firstOrDefault(), amount: 1 }, prices, priceProperty, fromCart )
      const looseadditionalAccessories = getAccessories( product.looseadditionalProduct.firstOrDefault() );
      for ( let looseacc of looseadditionalAccessories ) {
        if ( prices[looseacc] ) {
          productPrice += getProductPrice( { name: looseacc, amount: 1, priceUnit: 1 }, prices, priceProperty, fromCart );
        }
      }
    }
  }
  // and then multiply with the real amount
  return ( fromCart || lastAddedItem ) ? productPrice * ( product.amount || 1 ) : productPrice;
};

export const getProductPrice = ( product, prices, priceProperty = 'listPrice', fromCart ) => {
  let productPrice = prices[product.name] ? prices[product.name][priceProperty] : ( product[priceProperty] || 0 );
  const priceUnit = parseFloat( product.priceUnit || 1 );
  return fromCart ? productPrice * ( product.amount || 1 ) / priceUnit : productPrice / priceUnit;
};
export const getNSTPrice=(product,prices,fromCart=false,fromCartFooter=false,fromSelect=false,fromConfigFooter=false,skipLooseAcc=false,priceProperty = 'listPrice',fromSearch=false,lastAddedItem=false,onExport=false)=>{
  let NSTProductPrice=0;
  let code=product.superCodeLSO || product.FG;
  NSTProductPrice = lastAddedItem? getProductPrice( { name: code, amount: product.amount, priceUnit: 1 }, prices, priceProperty,fromCart )*product.amount:getProductPrice( { name: code, amount: product.amount, priceUnit: 1 }, prices, priceProperty,fromCart );
  let productPrice = getProductPrice( product, prices, priceProperty,fromCart );
  let additional_acc=[]
  let additionalPrice=0;
  const priceUnit = parseFloat( product.priceUnit || 1 );
  const accessories=getAccessories( product,fromCart );  
  for ( let accessory of accessories ) {
    if ( prices[accessory] ) {
      productPrice += getProductPrice( { name: accessory, amount: product.amount, priceUnit: 1 }, prices, priceProperty,fromCart );
    }
  }
  productPrice = lastAddedItem ? productPrice*product.amount:productPrice;
  if(product.additionalProducts && product.additionalProducts.length > 0 ){ 
    additional_acc = getAccessories( product.additionalProducts.firstOrDefault() );
    for ( let accessory of additional_acc ) {
      if(code && code!="待开"){
        if ( !product.bom?.any(b=>b.name==accessory) && prices[accessory] ) {
          additionalPrice += getProductPrice( { name: accessory, amount: product.amount, priceUnit: 1 }, prices,priceProperty,fromCart );
        }
      }
      else{
        if ( prices[accessory] ) {
          additionalPrice += getProductPrice( { name: accessory, amount: product.amount, priceUnit: 1 }, prices,priceProperty,fromCart );
        }
      }
    
  }
}
if(product.looseadditionalProduct && product.looseadditionalProduct.length > 0 ){
  additional_acc = getAccessories( product.looseadditionalProduct.firstOrDefault() );
  for ( let accessory of additional_acc ) {
    if(code && code!="待开"){
      if (  !product.bom?.any(b=>b.name==accessory && b.configuredAcc) && prices[accessory] ) {
        additionalPrice += getProductPrice( { name: accessory, amount: product.amount, priceUnit: 1 }, prices,priceProperty,fromCart );
      }
    }
  else{
    if (  prices[accessory] ) {
      additionalPrice += getProductPrice( { name: accessory, amount: product.amount, priceUnit: 1 }, prices,priceProperty,fromCart );
    }
  }
}
}
additionalPrice = lastAddedItem ? additionalPrice*product.amount:additionalPrice;
  const acc_list=accessories.concat(additional_acc)
  let NST_acc=[]
  if(product.bom && product.bom.length>0 ){
    NST_acc=product.bom.filter(b=>b.configuredAcc).map(b=>{if(b.configuredAcc) return b.name})
  }

  if(fromSearch ){
    
    if(fromConfigFooter && skipLooseAcc){
      return NSTProductPrice>0?NSTProductPrice:productPrice //return product configuration price without loose acc
    }
    else if(fromConfigFooter)
    {       
      return NSTProductPrice>0?NSTProductPrice+additionalPrice:additionalPrice?productPrice+additionalPrice:NSTProductPrice?NSTProductPrice:productPrice
    }
    return NSTProductPrice>0?NSTProductPrice:productPrice;
  }
  if(fromSelect ){
    if(accessories.length>0 && NST_acc.length>0){
      if(deepStrictEqual(acc_list,NST_acc)){
        return NSTProductPrice>0?NSTProductPrice:productPrice;
      }
      else{
        return productPrice;
      }
    }
    return NSTProductPrice>0?NSTProductPrice:productPrice;
  }

  if(!product.configurableProduct && product.FG){
    if(product.properties.any(p=>p.name=="VD4_MB")){
      return NSTProductPrice>0?NSTProductPrice:productPrice+additionalPrice

    }
    else{
    if(fromConfigFooter && skipLooseAcc){
      return NSTProductPrice>0?NSTProductPrice:productPrice //return product configuration price without loose acc
    }
    else if(fromConfigFooter|| lastAddedItem)
    {       
      return NSTProductPrice>0?NSTProductPrice+additionalPrice:productPrice+additionalPrice
    }
  }
  }
  if(accessories.length>0 && NST_acc.length>0){
    if(deepStrictEqual(acc_list.sort(),NST_acc.sort())){
      return fromCart?NSTProductPrice>0?NSTProductPrice/priceUnit:productPrice: NSTProductPrice>0?NSTProductPrice:productPrice;
    }
    else{
       if(fromConfigFooter && skipLooseAcc){
        return NSTProductPrice?NSTProductPrice:productPrice//return product configuration price without loose acc
      }
      else if(fromConfigFooter|| lastAddedItem)
      {       
        return NSTProductPrice?NSTProductPrice+additionalPrice:productPrice+additionalPrice
      }
    }
  } 
      if(fromCartFooter ){
        return NSTProductPrice?NSTProductPrice+additionalPrice:productPrice+additionalPrice
      } 
      if(fromCart){
        if((product.FG || product.superCodeLSO)!=='待开' && NSTProductPrice==0){
          return productPrice
        }
        return NSTProductPrice?NSTProductPrice:productPrice+additionalPrice

      }
      if(lastAddedItem){
        return NSTProductPrice>0?NSTProductPrice+additionalPrice:productPrice+additionalPrice
      }
      if( onExport){
        if((product.FG || product.superCodeLSO)!=='待开' && NSTProductPrice==0){
          return productPrice
        }
        return NSTProductPrice?NSTProductPrice:productPrice+additionalPrice
      }
  return productPrice;
}

export const convertToLineItem = ( product,user, externalId = null ) =>
{
	let newDistributionChannel = product.distributionChannel;
	if(user?.customerCurrencies[0]?.kunnr?.includes("12064")){
		newDistributionChannel = user?.customerCurrencies[0]?.vtweg;
	}
	return {
  materialName: product?.name || product?.Name|| product,
  materialNameLso: product.code || product.name ||product.Name|| product,
  materialGroup: product.materialGroupLso,
  productHierarchy: product.productHierarchyLso || product.productHierarchy,
  properties: {
    SalesDocumentType: product.salesDocumentType,
    SalesOrganization: product.salesOrganization,
    DistributionChannel: newDistributionChannel,
    SalesDivision: product.salesDivision,
    SalesOffice:product.salesOffice || null,
    ColumnSelected : product.columnSelected || null,
    externalId: externalId || extractDataFromJwt( UserIdentity.jwt ).content.properties.CustomerCode,
    customerCode: user.properties.CustomerCode || user.CustomerCode
  },  quantity: product.amount || 1
} ;}
export const convertFGToLineItem = ( product,user, externalId = null ) => ( {
  materialName: product?.name || product?.Name|| product,
  materialNameLso: product.code || product.name ||product.Name|| product,
  materialGroup: product.materialGroupLso,
  properties: {
    externalId: externalId || extractDataFromJwt( UserIdentity.jwt ).content.properties.CustomerCode,
    customerCode: user.properties.CustomerCode || user.CustomerCode
  },  quantity: product.amount || 1
} );
